import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { Button, Input } from 'reactstrap';
import { connect } from 'react-redux';

import './Problem.scss';

import commonConstant from '../../common/_commonConstant';
import { randomNumber } from '../../common/_commonFunction';
import { Modal, Dropdown, problemColor, problemName, validateMaxLength, isCashier, isOperation } from '../../helpers';
import { Loading } from '../../components';
import { fetchCreateProblem, fetchGetParkingProblems, fetchUpdateProblem, fetchDeleteProblem } from '../../actions';

class Problem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'selectType': null,
      'problemDetail': this.handleSetproblemDetail(props),
      'emptyProblemDetail': false,
      'loading': false,
    };
    this.problemModal = createRef();
    this.dropdown = createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { createProblem, parkingID, getParkingProblems, type, updateProblem, deleteProblem, getProfile } = this.props;

    if (
      (nextProps.createProblem && nextProps.createProblem !== createProblem) ||
      (nextProps.updateProblem && nextProps.updateProblem !== updateProblem) ||
      (nextProps.deleteProblem && nextProps.deleteProblem !== deleteProblem)
    ) {
      if (
        ((nextProps.createProblem.status === 200 && nextProps.createProblem.data.parkingID === parkingID) ||
          (nextProps.updateProblem.status === 200 && nextProps.updateProblem.data.parkingID === parkingID) ||
          (nextProps.deleteProblem.status === 200)) && isCashier(getProfile)
      ) {
        return this.props.dispatch(fetchGetParkingProblems(parkingID));
      } else if (isOperation(getProfile)) {
        return this.handleCancel();
      }
    } else if (nextProps.getParkingProblems && nextProps.getParkingProblems !== getParkingProblems) {
      return this.handleCancel();
    } else if (nextProps.type && nextProps.type !== type && nextProps.type === commonConstant.updateProblem) {
      return this.setState({ 'problemDetail': this.handleSetproblemDetail(nextProps) });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = event => {
    if (this.problemModal.current && !this.problemModal.current.contains(event.target)) {
      return this.handleCancel();
    }
    return;
  };

  handleSetproblemDetail = props => {
    const { type, problem } = props;
    try {
      if (type === commonConstant.updateProblem) {
        return problem.problemDetail ? problem.problemDetail : '';
      }
      return '';
    } catch (error) {
      return '';
    }
  }

  handleHeaderModal = () => {
    const { type } = this.props;

    if (!type) {
      return null;
    }

    switch (type) {
      case commonConstant.createProblem:
        return 'ปัญหาที่พบ';
      case commonConstant.updateProblem:
        return 'แก้ไขปัญหา';
      case commonConstant.deleteProblem:
        return 'แก้ไขปัญหา';
      default:
        return null;
    }
  }

  handleBodyModal = () => {
    const { type, problem, x2 } = this.props;
    const { selectType, problemDetail, emptyProblemDetail } = this.state;

    if (!type) {
      return null;
    }

    switch (type) {
      case commonConstant.createProblem:
        return (
          <div className="add-problem">
            <Dropdown
              id="select-problem-type"
              template="a"
              placeholder="เลือกหัวข้อปัญหา"
              value={
                selectType && selectType.problemName ?
                  <span className="show-select-type" id="problem-type">
                    <span className={`dot${problemColor(selectType) ? ` ${problemColor(selectType)}` : ''}`} />
                    <span className="value">{selectType.problemName}</span>
                  </span>
                  : null
              }
              error={emptyProblemDetail && !selectType ? true : false}
              ref={this.dropdown}
            >
              {this.handleProblemItem()}
            </Dropdown>
            <Input
              id="problem-detail"
              className={`detail${emptyProblemDetail && (!problemDetail || problemDetail.length) < 3 ? ' error' : ''}`}
              placeholder="กรอกปัญหาที่พบ"
              type="textarea"
              onChange={this.handleProblemDetail}
              value={problemDetail}
            />
            <div className="info-text">
              <span>ความยาวอย่างน้อย 3 ตัวอักษร และไม่เกิน 500 ตัวอักษร</span>
              <span>{problemDetail.length}/500</span>
            </div>
            <div className="error-text" id="problem-warning">
              {emptyProblemDetail ? 'กรุณาเลือกหัวข้อปัญหา และกรอกรายละเอียดอย่างน้อย3ตัวอักษร' : null}
            </div>
            <div className="box-btn">
              <Button className="btn-secondary" id="btn-create-problem" onClick={this.handleCreateProblem}>บันทึก</Button>
            </div>
          </div>
        );
      case commonConstant.updateProblem:
        return (
          <div className="update-problem">
            <span className="show-select-type" id="problem-type">
              <span className={`dot${problemColor(problem) ? ` ${problemColor(problem)}` : ''}`} />
              <span className="value">{problemName(problem)}</span>
            </span>
            <Input
              id="problem-detail"
              className={`detail${emptyProblemDetail && (!problemDetail || problemDetail.length) < 3 ? ' error' : ''}`}
              placeholder="กรอกปัญหาที่พบ"
              type="textarea"
              onChange={this.handleProblemDetail}
              value={problemDetail}
            />
            <div className="info-text">
              <span>ความยาวอย่างน้อย 3 ตัวอักษร และไม่เกิน 500 ตัวอักษร</span>
              <span>{problemDetail.length}/500</span>
            </div>
            <div className="error-text" id="problem-warning">
              {emptyProblemDetail && (!problemDetail || problemDetail.length) ? 'กรุณากรอกรายละเอียดอย่างน้อย3ตัวอักษร' : null}
            </div>
            <div className="box-btn">
              <Button className="btn-secondary" id="btn-update-problem" onClick={this.handleUpdateProblem}>บันทึก</Button>
            </div>
          </div>
        );
      case commonConstant.deleteProblem:
        return (
          <div className="delete-problem">
            <div className="box-icon" id="delete-icon">
              <span className="icon far fa-trash-alt" />
              <span className="circle">!</span>
            </div>
            <div className="text" id="delete-title">คุณต้องการลบปัญหานี้ใช่หรือไม่?</div>
            <div className="box-btn-confirm">
              {
                !x2 && <Button className="btn-cancel btn-thirdary" id="btn-cancel" onClick={this.handleCancel}>
                  ยกเลิก
                </Button>
              }
              <Button className="btn-confirm btn-fourthary" id="btn-delete-problem" onClick={this.handleDeleteProblem}>
                ลบ
              </Button>
              {
                x2 && <span className="btn-cancel" id="btn-cancel" onClick={this.handleCancel}>
                  ยกเลิก
                </span>
              }
            </div>
          </div>
        );
      default:
        return null;
    }
  }

  handleCancel = () => {
    this.setState({
      'selectType': null,
      'problemDetail': '',
      'emptyProblemDetail': false,
      'loading': false,
    });
    return this.props.handleCloseModal();
  }

  handleProblemItem = () => {
    const { getProblems } = this.props;
    const { selectType } = this.state;

    if (!getProblems) {
      return null;
    }

    return getProblems.map((ele, index) => (
      <div
        id={`problem-item-${index}`}
        className={`item${selectType && selectType.problemCode === ele.problemCode ? ' active' : ''}`}
        key={randomNumber()}
        onClick={() => this.handleSelectType(ele)}
      >
        <span className={`dot${problemColor(ele) ? ` ${problemColor(ele)}` : ''}`} />
        <span>{ele.problemName}</span>
      </div>
    ));
  }

  handleSelectType = selectType => {
    this.dropdown.current.handleShowItem();
    return this.setState({ selectType });
  }

  handleProblemDetail = event => {
    if (validateMaxLength(event.target.value, 500)) {
      return this.setState({ 'problemDetail': event.target.value });
    }
    return;
  }

  handleCreateProblem = () => {
    const { selectType, problemDetail } = this.state;
    const { parkingID } = this.props;

    if (!selectType || !problemDetail || problemDetail.length < 3 || !validateMaxLength(problemDetail, 500)) {
      return this.setState({ 'emptyProblemDetail': true });
    }

    this.setState({ 'emptyProblemDetail': false, 'loading': true });
    return this.props.dispatch(fetchCreateProblem(parkingID, {
      'problemID': selectType.problemID,
      problemDetail,
    }));
  }

  handleUpdateProblem = () => {
    const { problemDetail } = this.state;
    const { parkingID, problem, handleShowModalDelete } = this.props;

    if (problemDetail.length === 0) {
      this.setState({ 'emptyProblemDetail': false });
      return handleShowModalDelete();
    } else if (!problemDetail || problemDetail.length < 3) {
      return this.setState({ 'emptyProblemDetail': true });
    }

    this.setState({ 'emptyProblemDetail': false, 'loading': true });
    return this.props.dispatch(fetchUpdateProblem(parkingID, problem.parkingProblemID, {
      'problemID': problem.problemID,
      problemDetail,
    }));
  }

  handleDeleteProblem = () => {
    const { parkingID, problem } = this.props;

    this.setState({ 'loading': true });
    return this.props.dispatch(fetchDeleteProblem(parkingID, problem.parkingProblemID));
  }

  render() {
    const { type, show, getProblems, parkingID, x2 } = this.props;
    const { loading } = this.state;

    if (!type) {
      return null;
    } else if (!getProblems || !parkingID) {
      return <Loading />;
    }

    return (
      <Modal x2={x2} show={show} header={this.handleHeaderModal()} handleToggle={this.handleCancel}>
        {loading ? <Loading/> : null}
        <div className={`Problem${x2 ? ' x2' : ''}`} ref={this.problemModal}>
          {this.handleBodyModal()}
        </div>
      </Modal>
    );
  }
}

Problem.propTypes = {
  'dispatch': PropTypes.func.isRequired,
  'x2': PropTypes.bool,
  'type': PropTypes.string,
  'show': PropTypes.bool,
  'handleCloseModal': PropTypes.func.isRequired,
  'parkingID': PropTypes.string,
  'problem': PropTypes.shape({
    'problemID': PropTypes.string,
    'parkingProblemID': PropTypes.string,
    'problemName': PropTypes.string,
    'problemDetail': PropTypes.string,
  }),
  'handleShowModalDelete': PropTypes.func,
  'getProblems': PropTypes.array,
  'createProblem': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({
      'parkingID': PropTypes.string,
    }),
  }),
  'getParkingProblems': PropTypes.shape({}),
  'updateProblem': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({
      'parkingID': PropTypes.string,
    }),
  }),
  'deleteProblem': PropTypes.shape({
    'status': PropTypes.any,
  }),
  'getProfile': PropTypes.shape({}),
};

const mapStateToProps = ({ getProblems, createProblem, getParkingProblems, updateProblem, deleteProblem, getProfile }) => ({
  'getProblems': getProblems.data,
  createProblem,
  getParkingProblems,
  updateProblem,
  deleteProblem,
  'getProfile': getProfile.data,
});

export default connect(mapStateToProps)(Problem);
